// constants
import { TestParamMappingActionTypes } from './constants';
import { TestParamMapping as TestParamMappingData, TestParamsListing } from 'src/types/testParamMapping';

export type TestParamMappingActionType = {
    type:
        | TestParamMappingActionTypes.API_RESPONSE_SUCCESS
        | TestParamMappingActionTypes.API_RESPONSE_ERROR
        | TestParamMappingActionTypes.ADD_TEST_PARAM_MAPPING
        | TestParamMappingActionTypes.EDIT_TEST_PARAM_MAPPING
        | TestParamMappingActionTypes.GET_TEST_PARAM_MAPPING
        | TestParamMappingActionTypes.GET_TEST_PARAM_MAPPINGS
        | TestParamMappingActionTypes.GET_TEST_PARAMS
        | TestParamMappingActionTypes.RESET
        | TestParamMappingActionTypes.RESET_SUCCESS
        | TestParamMappingActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const testParamMappingApiResponseSuccess = (
    actionType: string,
    data: TestParamMappingData | TestParamsListing | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): TestParamMappingActionType => ({
    type: TestParamMappingActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const testParamMappingApiResponseError = (
    actionType: string,
    data: TestParamMappingData | TestParamsListing | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): TestParamMappingActionType => ({
    type: TestParamMappingActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addTestParamMapping = (params: any): TestParamMappingActionType => ({
    type: TestParamMappingActionTypes.ADD_TEST_PARAM_MAPPING,
    payload: params,
});

export const editTestParamMapping = (params: any): TestParamMappingActionType => ({
    type: TestParamMappingActionTypes.EDIT_TEST_PARAM_MAPPING,
    payload: params,
});

export const GetTestParamMappings = (params: any): TestParamMappingActionType => ({
    type: TestParamMappingActionTypes.GET_TEST_PARAM_MAPPINGS,
    payload: params,
});

export const GetTestParamMapping = (params: any): TestParamMappingActionType => ({
    type: TestParamMappingActionTypes.GET_TEST_PARAM_MAPPING,
    payload: params,
});

export const GetTestParamListing = (params: any): TestParamMappingActionType => ({
    type: TestParamMappingActionTypes.GET_TEST_PARAMS,
    payload: params,
});

export const resetTestParamMapping = (): TestParamMappingActionType => ({
    type: TestParamMappingActionTypes.RESET,
    payload: {},
});

export const resetTestParamMappingSuccess = (): TestParamMappingActionType => ({
    type: TestParamMappingActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetTestParamMappingError = (): TestParamMappingActionType => ({
    type: TestParamMappingActionTypes.RESET_ERROR,
    payload: {},
});
